<template>
  <div class="basic-layout">
    <Header />
    <main class="main-content">
      <slot />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'BasicLayout',
  components: { Header, Footer },
};
</script>

<style scoped lang="scss">
.basic-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f7faff;
  .main-content {
    flex: 1;
    width: 100%;
    margin: 0 auto;
    padding: 32px 0 32px 0;
    box-sizing: border-box;
  }
}
@media (max-width: 900px) {
  .basic-layout .main-content {
    margin-top: 50px;
    padding: 16px 0 16px 0;
  }
}
</style>
